import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api/v1/travel/cars"; // adjust if your route differs

export const getCars = () => axios.get(API);
export const createCar = (data: any) => axios.post(API, data);
export const deleteCar = (id: string) => axios.delete(`${API}/${id}`);

// ✅ NEW
export const updateCar = (id: string, data: any) =>
  axios.put(`${API}/${id}`, data);
